import { render } from "./IzinSiswa.vue?vue&type=template&id=36d9dcdc&scoped=true"
import script from "./IzinSiswa.vue?vue&type=script&lang=js"
export * from "./IzinSiswa.vue?vue&type=script&lang=js"

import "./IzinSiswa.vue?vue&type=style&index=0&id=36d9dcdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d9dcdc"]])

export default __exports__